import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { appendStyle } from '@1inch-community/core/lit-utils';
import { OverlayViewMode, OverlayViewPopupPosition, } from '@1inch-community/models';
import { html } from 'lit';
import { AsyncDirective } from 'lit/async-directive.js';
import { directive, PartType } from 'lit/directive.js';
import { styleMap } from 'lit/directives/style-map.js';
import { debounceTime, fromEvent, merge, switchMap, tap, timer } from 'rxjs';
import './tooltip.element';
class TooltipDirective extends AsyncDirective {
    constructor(partInfo) {
        super(partInfo);
        this.partInfo = partInfo;
        this.overlayId = null;
        this.options = { text: '' };
        if (this.partInfo.type !== PartType.ELEMENT) {
            throw new Error('tooltip directive support only elements');
        }
        this.context = lazyAppContextConsumer(partInfo.options.host);
        this.subscription = merge(this.mouse(), this.touch()).subscribe();
        appendStyle(partInfo.element, {
            cursor: 'pointer',
        });
    }
    render(text) {
        if (typeof text === 'string') {
            this.options = { text };
        }
        else {
            this.options = text;
        }
    }
    disconnected() {
        this.subscription.unsubscribe();
    }
    mouse() {
        const mouseleave$ = fromEvent(this.partInfo.element, 'mouseleave').pipe(debounceTime(this.options.closeDelay ?? 200), tap(async () => {
            await this.closeTooltip();
        }));
        return fromEvent(this.partInfo.element, 'mouseenter').pipe(debounceTime(this.options.openDelay ?? 500), switchMap(async () => this.openTooltip(true)), switchMap(() => mouseleave$));
    }
    touch() {
        return fromEvent(this.partInfo.element, 'touchstart').pipe(switchMap(async () => this.openTooltip(false)), switchMap(() => timer(3000).pipe(tap(() => this.closeTooltip()))));
    }
    async openTooltip(checkHover) {
        if (this.overlayId || (checkHover && !this.partInfo.element.matches(':hover')))
            return;
        const style = {
            maxWidth: this.options.maxWidth ? `${this.options.maxWidth}px` : undefined,
            maxHeight: this.options.maxHeight ? `${this.options.maxHeight}px` : undefined,
        };
        this.overlayId = await this.context.value.overlay.open(html `<inch-tooltip style="${styleMap(style)}" text="${this.options.text}"></inch-tooltip>`, {
            mode: OverlayViewMode.popup,
            position: {
                x: [
                    OverlayViewPopupPosition.center,
                    OverlayViewPopupPosition.right,
                    OverlayViewPopupPosition.left,
                ],
                y: [OverlayViewPopupPosition.top, OverlayViewPopupPosition.bottom],
            },
            targetFactory: () => this.partInfo.element,
            customOverlayContainerStyle: {
                borderRadius: '4px',
            },
        });
        if (checkHover && !this.partInfo.element.matches(':hover')) {
            await this.closeTooltip();
        }
    }
    async closeTooltip() {
        if (this.overlayId && this.context.value.overlay.isOpenOverlay(this.overlayId)) {
            await this.context.value.overlay.close(this.overlayId);
        }
        this.overlayId = null;
    }
}
export const tooltip = directive(TooltipDirective);
//# sourceMappingURL=tooltip.directive.js.map